module.exports = __webpack_public_path__ + "img/Rooms_text04_feedback.0321bb3e.png";